import { Box } from '@mui/material';

/**
 * Brand logos served from /public.
 *  - brand 'leano' (color PNG with dark navy text/marks) - ALWAYS rendered in
 *    its original colors. On dark surfaces it is placed on a soft light pill
 *    so the dark text remains crisp and readable.
 *  - brand 'izzat' (white PNG, designed for dark backgrounds)
 *
 * variant:
 *   'dark'  -> logo is being placed on a LIGHT background.
 *   'light' -> logo is being placed on a DARK background.
 */
export default function BrandLogo({ brand = 'leano', variant = 'dark', height = 36, sx = {}, alt }) {
  const isIzzat = brand === 'izzat';
  const file = isIzzat ? '/izzat-logo-white.png' : '/leano-logo.png';
  const label = alt || (isIzzat ? 'Izzat Technologies' : 'Leano');

  // Only Izzat needs color treatment when shown on a light background
  // (white-on-white invisible). Leano is left in its original colors.
  let filter = 'none';
  if (isIzzat && variant === 'dark') {
    filter = 'brightness(0) saturate(100%) invert(11%) sepia(43%) saturate(2331%) hue-rotate(207deg) brightness(94%) contrast(98%)';
  }

  const img = (
    <Box
      component="img"
      src={file}
      alt={label}
      sx={{
        height,
        width: 'auto',
        display: 'block',
        objectFit: 'contain',
        filter
      }}
    />
  );

  // Leano on a dark surface -> wrap in a light pill so its dark text reads well.
  if (!isIzzat && variant === 'light') {
    const padY = Math.max(4, Math.round(height * 0.18));
    const padX = Math.max(10, Math.round(height * 0.32));
    return (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#ffffff',
          borderRadius: `${Math.round(height * 0.28)}px`,
          px: `${padX}px`,
          py: `${padY}px`,
          boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
          ...sx
        }}
      >
        {img}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'inline-flex', ...sx }}>
      {img}
    </Box>
  );
}
